/**
 * lib/desktop.ts — puente hacia electron/preload.js.
 * Fuera de la app instalada (navegador normal), todo esto es un no-op
 * seguro: procreditoDesktop simplemente no existe en window.
 */

interface ProcreditoDesktopBridge {
  isDesktopApp: boolean
  retryConnection: () => void
  minimize?: () => void
  close?: () => void
  setCompactMode?: (compact: boolean) => void
  onCompactModeChanged?: (callback: (compact: boolean) => void) => () => void
}

function bridge(): ProcreditoDesktopBridge | undefined {
  return (window as unknown as { procreditoDesktop?: ProcreditoDesktopBridge }).procreditoDesktop
}

export function isElectronDesktop(): boolean {
  return typeof window !== 'undefined' && Boolean(bridge()?.isDesktopApp)
}

export function desktopMinimize() {
  bridge()?.minimize?.()
}

export function desktopClose() {
  bridge()?.close?.()
}

export function setDesktopCompactMode(compact: boolean) {
  bridge()?.setCompactMode?.(compact)
}

/** Devuelve la función de limpieza (unsubscribe). No-op fuera de Electron. */
export function subscribeDesktopCompactMode(callback: (compact: boolean) => void): () => void {
  const unsub = bridge()?.onCompactModeChanged?.(callback)
  return unsub ?? (() => {})
}
